import {Auth0ContextInterface} from "@auth0/auth0-react";
import {NavigationIntent} from "../AuthContext";


export function onAuth0Logout(
    auth0Context: Auth0ContextInterface,
    redirectCallback: NavigationIntent,
) {
    console.log('onAuth0Logout', redirectCallback.route);
    auth0Context.logout({
        openUrl: () => {
            redirectCallback.navigate(redirectCallback.route);
        }
    });
}
